import { ReactNode } from 'react';
import Image from 'next/image';

import { Box, BoxProps, Flex, useToken } from '@chakra-ui/react';
import { headerHeight } from '@udacity/udacity-header-v2';

import { ContentContainer } from '~/components/container';
import { PlanCardSectionTitle } from '~/features/plans/components/plan-card-section-title';

export type IndividualPlansSectionV2LayoutProps = {
  title?: string;
  titleSize?: 'h1' | 'h2';
  sectionHeaderSlot: ReactNode;
  cardsSlot: ReactNode;
  relatedProgramsCarouselSlot: ReactNode;
  containerProps?: BoxProps;
};

export function IndividualPlansSectionV2Layout({
  title,
  titleSize,
  sectionHeaderSlot,
  cardsSlot,
  relatedProgramsCarouselSlot,
  containerProps,
}: IndividualPlansSectionV2LayoutProps) {
  return (
    <Box {...containerProps} display='block' scrollMarginTop={headerHeight}>
      <Box
        as='section'
        bgGradient='linear(180deg, #F2F6FF, #C6DAF8)'
        overflow='hidden'
        position='relative'
        padding={{
          base: '40px 0px',
          md: '80px 0px',
        }}
      >
        <LinesBackground />
        <ContentContainer maxW={{ base: '100%', xl: '1400px' }} position='relative'>
          <Flex
            flexDir={{
              base: 'column',
            }}
            gap={{
              base: 4,
              xl: 10,
            }}
          >
            {title && titleSize && <PlanCardSectionTitle as={titleSize} title={title} />}
            {sectionHeaderSlot}
            <Flex alignItems='center' flexDir='column' gap='24px'>
              {cardsSlot}
            </Flex>
          </Flex>
        </ContentContainer>
        {relatedProgramsCarouselSlot}
      </Box>
    </Box>
  );
}

function LinesBackground() {
  const [contentMaxWidthMd] = useToken('sizes', ['content-max-width-md']);
  return (
    <Box
      left={`calc((100vw - ${contentMaxWidthMd})/2)`}
      opacity={0.5}
      pointerEvents='none'
      position='absolute'
      top='70%'
      transform='translate(-30%, -50%)'
      display={{
        base: 'none',
        md: 'block',
      }}
    >
      <Box height='914px' position='relative' width='2440px'>
        <Image
          alt=''
          quality={100}
          sizes='2440px'
          src='/images/backgrounds/blue-lines-wide.png'
          style={{
            objectFit: 'cover',
            objectPosition: 'right bottom',
          }}
          fill
        />
      </Box>
    </Box>
  );
}
